module.exports = __webpack_public_path__ + "img/m1.2f52f42e.png";